import React from 'react'
import { Link } from 'react-router-dom'

const Error = () => {
  return (
    <section className ="error-page section">
      <div className ="error-container">
        <h2>Sorry you messed somting up :( </h2>
        <Link to ="/" className  ="btn-primary">Step back!</Link>
      </div>
    </section>
  )
}

export default Error
